const headers = ["Integrated", "Custom"];

const processors = [
  "Stripe",
  "Checkout.com",
  "Adyen",
  "Amazon Payment Services",
  "PayTabs",
  "Noon Payments",
  "JumiaPay",
];

export const PaymentProcessors = () => {
  return (
    <div className="text-primary flow-root overflow-x-auto">
      <div className="border inline-block rounded-md align-middle">
        <table className="table-fixed divide-y min-w-[600px] w-full max-w-[810px] divide-gray-300">
          <thead>
            <tr className="text-sm text-left font-bold divide-x divide-gray-200">
              {headers.map((header, index) => (
                <th
                  key={`processors-header-${index}`}
                  scope="col"
                  className="whitespace-nowrap w-1/2 first-of-type:rounded-tl-md last-of-type:rounded-tr-md h-9 px-4 leading-4 bg-secondary-darkest text-white"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y text-xs font-semibold divide-white bg-white">
            {processors.map((processor, index) => (
              <tr key={`processors-${index}`}>
                <td className="h-11 px-4 leading-4 bg-lightgray">
                  {processor}
                </td>
                {index == 0 && (
                  <td rowSpan={processors.length} className="px-4 leading-4">
                    Please refer to your specific Custom Service Module Policy,
                    if applicable.
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
